<template>
<v-form 
	ref="form"
	v-model="formValid"
	lazy-validation
	@submit="formSubmit" enctype="multipart/form-data">
	<v-row align="center" justify="center">
		<v-col cols="12" md="6">
			<v-file-input 
				:loading="uploading"
				:disabled="uploading || uploaded"
				:label="label"
				:rules="rules"
				accept="image/png, image/jpeg"
				v-model="file"
				hint="Click upload after selecting file">
				<!-- accept="image/*" -->

				<!-- show-size 
				counter  -->
			</v-file-input>
		</v-col>
		<v-col cols="12" md="2">
			<v-btn 
				v-show="!uploaded"
				type="submit" 
				:disabled="!file || uploading">
				Upload
			</v-btn>
			<v-btn 
				v-show="uploaded"
				@click="reupload()"
				:disabled="!file || uploading">
				<!-- <v-icon left v-show="uploaded">mdi-check</v-icon> -->
				Reupload
			</v-btn>
		</v-col>
	</v-row>
</v-form>
</template>
   
<script>
import Axios from 'axios'
import Constants from '../../services/constants';
import Notify from '../../services/notify'

export default {
	name: 'FileUploader',
	props: [ 'allowedTypes', 'label' ],
	data() {
		return {
			file: null,
			success: '',
			formValid: null,
			uploadId: null,
			uploaded: false,
			uploading: false,      
			rules: [
				value => !value || value.size < 12000000 || 'Image size should be less than 12 MB',
				value => !value 
					|| (value.type == 'image/jpeg' || value.type == 'image/png') 
					|| 'Image must be JPEG or PNG format',
      ],
		};
	},
	methods: {
		reupload() {
			this.file = null;
			this.uploaded = false;
			this.uploading = false;
			this.$emit('reset-upload');
		},

		formSubmit(e) {
			e.preventDefault();
			if(!this.$refs.form.validate()) {
				Notify.toast('Invalid file selected', 'error');
				return;
			}
			const config = {
				headers: { 'content-type': 'multipart/form-data' }
			}

			let formData = new FormData();
			formData.append('file', this.file);

			if(this.uploadId) {
				formData.append('uploadId', this.uploadId);
			}

			this.uploading = true;
			Axios.post(Constants.API.UPLOAD, formData, config)
			.then((response) => {
				this.uploadId = response.data;
				this.uploaded = true;
				this.uploading = false;

				Notify.success.uploadSuccess();
				this.$emit('file-uploaded', {uploadId : this.uploadId});
			})
			.catch(() => {
				Notify.error.uploadFailed();
				this.uploaded = false;
				this.uploading = false;
			});
		}
	}
}
</script>